import { RouteRecordRaw } from 'vue-router'

export default {
	path: '/shipper',
	meta: {
		title: 'shared.shipperCompany'
	},
	children: [
		{
			path: 'companies',
			component: {
				name: 'ShipperCompanies',
				render() {
					return h(resolveComponent('router-view'))
				}
			},
			meta: {
				title: 'shared.companies'
			},
			children: [
				{
					path: '',
					name: 'ShipperCompaniesReport',
					component: () => import('../pages/companies/report.vue')
				},
				{
					path: 'create',
					name: 'ShipperCompaniesCreate',
					component: () => import('../pages/companies/create.vue'),
					meta: {
						title: 'shared.createCompany'
					}
				},
				{
					path: ':id',
					name: 'ShipperCompaniesDetail',
					component: () => import('../pages/companies/detail.vue'),
					meta: {
						title: 'shared.companyDetail',
						dynamicBreadcrumb: 'companyName'
					}
				}
			]
		},
		{
			path: 'users',
			component: {
				name: 'ShipperUsers',
				render() {
					return h(resolveComponent('router-view'))
				}
			},
			meta: {
				title: 'shared.users'
			},
			children: [
				{
					path: '',
					name: 'ShipperUsersReport',
					component: () => import('../pages/users/report.vue')
				},
				{
					path: 'create',
					name: 'ShipperUsersCreate',
					component: () => import('../pages/users/detail.vue'),
					meta: {
						title: 'shared.createUser'
					}
				},
				{
					path: ':id',
					name: 'ShipperUsersDetail',
					component: () => import('../pages/users/detail.vue'),
					props: true,
					meta: {
						title: 'shared.userDetail',
						dynamicBreadcrumb: 'userName'
					}
				}
			]
		},
		{
			path: 'locations',
			component: {
				name: 'ShipperLocations',
				render() {
					return h(resolveComponent('router-view'))
				}
			},
			meta: {
				title: 'shared.locations'
			},
			children: [
				{
					path: '',
					name: 'ShipperLocationsReport',
					component: () => import('../pages/locations/report.vue')
				},
				{
					path: 'create',
					name: 'ShipperLocationsCreate',
					component: () => import('../pages/locations/detail.vue'),
					meta: {
						title: 'shared.createLocation'
					}
				},
				{
					path: ':id',
					name: 'ShipperLocationsDetail',
					component: () => import('../pages/locations/detail.vue'),
					props: true,
					meta: {
						title: 'shared.locationDetail',
						dynamicBreadcrumb: 'locationName'
					}
				}
			]
		}
	]
} as RouteRecordRaw
